import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
const ComponentsDashboard = lazy(() => import('../containers/Components/ComponentsDashboard'));
const ComponentDetailsPage = lazy(() => import('../containers/Components/ComponentDetails/ComponentDetailsPage'));
function ComponentsRouts() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "details/:componentId", element: React.createElement(ComponentDetailsPage, null) }),
        React.createElement(Route, { path: "*", element: React.createElement(ComponentsDashboard, null) })));
}
export default ComponentsRouts;
